import { Typography } from "@mui/material";
import CircularProgressWithLabel from "components/elements/CircularProgressWithLabel";
import { fontWeight } from "config/Theme/options";
import { useUserDataContext } from "context/UserDataContext";
import { useTranslation } from "react-i18next";
import { WeeklyQuizStatus } from "types/enums";

import { StyledBadge } from "../styles";

const ChallengeBadge = () => {
  const { t } = useTranslation();
  const { bitcoinerChallenge } = useUserDataContext();

  const getProgressPercentage = (currentXP: number, maxXP: number) => {
    if (maxXP === 0) return 0;
    return Math.round((100 * currentXP) / maxXP);
  };

  return (
    <StyledBadge
      badgeContent={t("bottomNavigation.challenge.badge")}
      invisible={!bitcoinerChallenge || bitcoinerChallenge.weeklyQuizStatus === WeeklyQuizStatus.DONE}
      color="primary"
      size={"normal"}>
      <CircularProgressWithLabel
        value={bitcoinerChallenge ? getProgressPercentage(bitcoinerChallenge.xpTotal, bitcoinerChallenge.xpForNextLevel) : 0}
        size={28}
        label={
          <Typography fontSize={"0.625rem"} color={"primary.main"} fontWeight={fontWeight.semiBold}>
            {t("bottomNavigation.challenge.xp")}
          </Typography>
        }
      />
    </StyledBadge>
  );
};

export default ChallengeBadge;
